import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getMoveOrganizationalUnitError() {
      return getState().error;
    },
    isMoveOrganizationalUnitRequestFailure() {
      return getState().request.isFailure;
    },
    isMoveOrganizationalUnitRequestPending() {
      return getState().request.isPending;
    },
    isMoveOrganizationalUnitRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
